import { Link } from 'react-router-dom';

export default function CTABand() {
  return (
    <section className="bg-accent-500 py-14 md:py-16">
      <div className="container-site">
        <div className="flex flex-col items-center gap-6 text-center">
          <h2 className="font-heading text-2xl text-background-50 md:text-3xl">
            看漫画前先补课，追更不迷路
          </h2>
          <p className="max-w-xl text-sm leading-7 text-background-50/90 md:text-base">
            从故事主线到核心设定，从人物关系到分集看点，这里帮你把《泡在我家的辣妹》一次理清。
          </p>
          <div className="flex flex-col items-center gap-3 sm:flex-row">
            <Link
              to="/episodes"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-medium text-accent-900 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <i className="ri-list-check-2" />
              浏览分集剧情
            </Link>
            <Link
              to="/plot"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/15 cursor-pointer"
            >
              查看故事主线
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}